import { render } from "./DeveloperItemTimeline.vue?vue&type=template&id=5493c4c0"
import script from "./DeveloperItemTimeline.vue?vue&type=script&lang=js"
export * from "./DeveloperItemTimeline.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__